import '../../../App.css';
import React, { useState } from 'react';


const SimpleMode = () => {

    const [selectedUser, setSelectedUser] = useState("");
    const handleUserChange = (event) => {
        // const  = event.target.value;
        setSelectedUser(event.target.value);
    };
    const [user, ] = useState([]);
    const [loading, ] = useState(true);
    const [error, ] = useState(null);
    // State to manage the mode (on or off)
    const [isFullMode, ] = useState(false);

  

    return (
        <>

            <div style={{ marginTop: '20px',width:"100%" }}>



                {/* Conditional rendering based on isFullMode */}
                <div  style={{ marginTop: '20px',width:"100%" }}>
                    {isFullMode ? (
                        <div>
                            <SimpleMode />

                        </div>
                    ) : (
                        <div style={{ backgroundColor: '#EFEFEF', padding: '20px', borderRadius: '8px', marginTop: '20px', display: 'flex', alignItems: 'center' }}>

                            {/* Account Dropdown */}
                            <div className="container" style={{ marginTop: '20px' }}>

                                <div className="container" style={{ marginTop: '20px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <h4 style={{ color: "#1E90FF" }}>Scan for Next Task Completion</h4>
                                        <h4 style={{ color: "#1E90FF", marginRight: "240px" }}>Scan Settings</h4>

                                    </div>
                                </div>

                                {/* Account Dropdown Below the Heading */}
                                <div className="container" style={{ marginTop: '20px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        {/* Account Dropdown */}
                                        <div className="col-3" style={{ display: 'flex', alignItems: 'center' }}>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <label htmlFor="caseNumber" className="form-label" style={{ marginRight: '40px' }}>Case #</label>
                                                <input
                                                    type="text"
                                                    id="caseNumber"
                                                    name="caseNumber"
                                                    className="form-control"

                                                    style={{ width: '180px' }} // Adjust width as needed
                                                />
                                            </div>
                                        </div>
                                        {/* User Dropdown */}
                                        <div className="col-3" style={{ display: 'flex', alignItems: 'center', marginRight: '120px' }}>
                                            <label htmlFor="user" className="form-label" style={{ marginRight: '10px' }}>User</label>
                                            <select
                                                id="user"
                                                name="user"
                                                className="form-select form-select-sm"
                                                style={{ width: '180px', height: "35px", borderRadius: "5px" }} // Adjust width as needed
                                                value={selectedUser}
                                                onChange={handleUserChange}
                                            >
                                                <option value="" disabled>Select User</option>
                                                {loading && <option>Loading...</option>}
                                                {error && <option>{error}</option>}
                                                {!loading && !error &&
                                                    user.map((user) => (
                                                        <option key={user.id} value={user.id}>
                                                            {user.user_name}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

        </>
    );
};

export default SimpleMode;
